import { Injectable } from '@angular/core';
import { TaxonomyTermPages } from '@app/graphql';
import { combineLatest, Observable, map, tap, shareReplay } from 'rxjs';

import { Taxonomies, StoreName, CONSTANTS } from '@app/constants';
import { TaxonomyService, TaxonomyStoreService, PagesService, ScreenService } from '@app/data';
 
@Injectable({
  providedIn: 'root'
})
export class PageService {
  
  public currentTaxonomyPage$: Observable<TaxonomyTermPages | any>;

  private taxonomyDone$ = this.taxonomy.taxonomyDone$;
  private route$ = this.pages.route$;

  constructor(
    private taxonomy: TaxonomyService,
    private taxonomyStore: TaxonomyStoreService,
    private pages: PagesService,
    private screen: ScreenService
  ) {
      this.currentTaxonomyPage$ = combineLatest([
        this.taxonomyDone$,
        this.route$
      ]).pipe(
        tap(_ => console.log('$$$$ PageService currentTaxonomyPage$ _ ', _)),
        //filter(pages => pages[0].entityLabel! !== ''),
        //switchMap(([pages, pageName]) => pages.filter(page =>  page!.entityLabel!.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === pageName)),
        map(([taxonomy, page]) => {
          console.log('PageService this.currentTaxonomyPage$ page ', page);
          //console.log('PageService this.currentTaxonomyPage$ taxonomy ', taxonomy);
          //console.log('PageService this.currentTaxonomyPage$ page.pageName ', page.pageName);

          if (page.url === '') {
            return [];
          }

          const pageName = page.pageName;
          let activeItem;
        
          if (pageName === '/uvod') {

            activeItem =  {
              entityLabel: 'Úvod',
              title: '',
              entityUrl: {path: '/uvod'},
              field_image_url: CONSTANTS.baseUrl + '/sites/default/files/2021-05/MNTM_home.jpg',
              url: '/uvod',
              summary: 'portál moderního vzdělávání'
            };
          }
          else if (pageName === '/hledat') {
            activeItem =  {
              entityLabel: 'Hledat',
              title: 'Hledat',
              entityBundle: 'no-image',
              entityUrl: {path: '/hledat'},
              url: '/hledat'
            };
          }

          else if (pageName === '/navigace') {
            activeItem =  {
              entityLabel: 'Navigace',
              title: '',
              entityBundle: 'no-image',
              entityUrl: {path: '/navigace'},
              url: '/navigace'
            };
          }

          else if (pageName === '/uzivatel') {
            activeItem =  {
              entityLabel: 'Uživatel',
              title: '',
              entityBundle: 'no-image',
              entityUrl: {path: '/uzivatel'},
              url: '/uzivatel'
            };
          }
          else {

            let parentUrl = page.parentPageUrl;
            let url = page.url;
            let backBtn: any = false;
            let newPage: any;
            let entityUrl: string;

            /* DETAIL */
            if (page.data.detail) {
              url = page.url;

              if (page.pageName.includes('/inspirace/inspirativni-skoly')) {
                entityUrl = page.pageName.replace('/inspirace/inspirativni-skoly', '');
              }
              else if (page.pageName.includes('/inspirace/inspirativni-organizace')) {
                entityUrl = page.pageName.replace('/inspirace/inspirativni-organizace', '');
              }
              else {
                entityUrl = page.pageName;
              }

              newPage = this.taxonomyStore.getTaxonomyEntity(entityUrl);
              backBtn = {
                entityLabel: newPage.entityLabel,
                url: page.pageName
              };
            }
            /* SCHOOL */
            else if (page.params.school) {
              entityUrl = page.url.replace(parentUrl, '');
              newPage = this.taxonomyStore.getTaxonomyEntity(entityUrl);
            }
            /* REST */
            else {
              entityUrl = url;
              newPage = this.taxonomyStore.getTaxonomyEntity(entityUrl);
            }

            console.log('PageService currentTaxonomyPage$ entityUrl ', entityUrl);
            console.log('PageService currentTaxonomyPage$ newPage ', newPage);

            /* CHIPS */

            let chips = [];

            if (newPage.fieldTags !== undefined && !newPage.chips) {
              chips = newPage.fieldTags.length > 0 ? this.taxonomy.getChipsFromArticle(newPage) : [];
            }

            /* LABEL */

            let newLabel = newPage.entityLabel;

            // GET LABEL FOR SUBPAGE
            if (page.subPage && newPage && page.data.detail) {
              
              newLabel = newLabel + ' / ' + this.taxonomyStore.getTaxonomyEntity(page.subPage).entityLabel;
              console.log('PageService currentTaxonomyPage$ newLabel ', newLabel);
            }

            /* BACK BTN */

            if (backBtn) {
              backBtn.entityLabel = newLabel;
            }

            //  ON SCHOOL

            if (page.params.school) {
              backBtn = this.taxonomyStore.getTaxonomyEntity(page.parentPageUrl);
            }

            //console.log('PageService currentTaxonomyPage$ backBtn ', backBtn);

            activeItem = {
              ... newPage,
              title: newLabel,
              chips,
              backBtn
            };
          }

          console.log('PageService currentTaxonomyPage$ activeItem ', activeItem);

          // if not a detail set the screen from here
          if (!page.data.detail) {

            let showPlayBtn: boolean;

            if (page.params.school) {             
              showPlayBtn = ( activeItem.field_video_id && activeItem.field_video_platform ) ? true : false;
            }
            else {
              showPlayBtn = false;
            }

            this.screen.setScreenStore({
              activeItem,
              prev: false,
              next: false,
              showPlayBtn,
            });

            //console.log('PageService currentTaxonomyPage$ activeItem ', activeItem);
          }

          return activeItem;
        }),
        //map(currentPage => currentPage[0]),
        /*tap(_ => {
          console.log('PageService currentTaxonomyPage$ _ ', _);

          //return currentPage;
        }),*/
        shareReplay({ bufferSize: 1, refCount: true })
      );
  }

  public getTaxonomyPages$ = (storeName: StoreName): Observable<Taxonomies[]> => this.taxonomyStore.getTaxonomyPages$(storeName);
  public getSectionPages$ = (storeName: StoreName, entityId: string): Taxonomies => this.taxonomyStore.getSectionPages$(storeName, entityId);
  private isArray = (obj : any ) => Array.isArray(obj);
}
